import * as React from "react";
import { Modal } from "antd";

interface Props extends React.PropsWithChildren {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}
export const TableModal: React.FC<Props> = ({ open, onCancel, onOk, children }) => {
  if (!open) {
    return null;
  }
  return (
    <Modal
      width={"90vw"}
      styles={{ body: { height: "70vh", padding: 0 } }}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      destroyOnHidden={true}
      maskClosable={false}
    >
      <div className="h-full overflow-auto p-1">{children}</div>
    </Modal>
  );
};
